import { size } from "../foundation";

export const spacing = {      // margin, padding, gap
    none: size[0],   //  0rem      0px
    tiny: size[100], //  0.25rem   4px
    xxs: size[200],  //  0.5rem    8px
    xs: size[300],   //  0.75rem   12px
    sm: size[400],   //  1rem      16px
    md: size[500],   //  1.25rem   20px
    lg: size[600],   //  1.5rem    24px
    xl: size[700],   //  1.75rem   28px
    xxl: size[800],  //  2rem      32px
    huge: size[900], //  2.25rem   36px
}

export default spacing;